module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_02.7828af93.svg";